<template>
  <div class="mobile treasure-box-progress">
    <div class="progress-wrap">
      <div class="progress-inner-wrap">
        <div class="progress-inner" :style="{ height: calcProgress(mwrData.shootDetail.totalUserDpsScore) + '%' }"></div>
        <div class="box1-line" :style="{ bottom: calcProgress(mwrData.commonConfig.firstStageScore) + '%' }"></div>
        <div class="box2-line" :style="{ bottom: calcProgress(mwrData.commonConfig.secondStageScore) + '%' }"></div>
        <div class="box3-line" :style="{ bottom: calcProgress(mwrData.commonConfig.thirdStageScore) + '%' }"></div>
      </div>
    </div>
    <div class="box box1" :class="{ disabled: getBoxStatus(1) === 0, rockAnimation: getBoxStatus(1) === 1 }" @click="handleClickBox(1)"></div>
    <div class="box box2" :class="{ disabled: getBoxStatus(2) === 0, rockAnimation: getBoxStatus(2) === 1 }" @click="handleClickBox(2)"></div>
    <div class="box box3" :class="{ disabled: getBoxStatus(3) == 0, rockAnimation: getBoxStatus(3) === 1 }" @click="handleClickBox(3)"></div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { reactive } from 'vue'
import { defineProps } from 'vue'
import { inject } from 'vue'
import { toastService } from '@/utils/toastService'
import { useI18n } from 'vue-i18n'
import MwrActApi from '@/config/mwrActApi'
const mwrFn = inject('mwrFn')
const { t } = useI18n()
const mwrData = inject('mwrData')
const emit = defineEmits(['openRewardBoxDialog'])
const props = defineProps({
  currentProgress: {
    type: Number,
    default: 0,
  }
})
// const state = reactive({
//   total: 20260,
//   box1Progress: 4052,
//   box2Progress: 10130,
//   box3Progress: 20260,
// })
const getBoxStatus = (stage) => {
  const totalUserDpsScore = mwrData.shootDetail.totalUserDpsScore
  // 0-未完成 1-可领取 2-已领取
  const recordList = mwrData.recordList
  const awardBox = mwrData.commonConfig.awardBoxList.find(item => item.stage === stage)
  if (totalUserDpsScore < awardBox.score) {
    return 0 // 未完成
  }
  const record = recordList.find(item => item.stage === stage)
  if (record) {
    return 2 // 已领取
  }
  return 1
}

const calcProgress = (progress) => {
  if (progress >= mwrData.commonConfig.totalScore) {
    return 100
  }
  return (progress / mwrData.commonConfig.totalScore) * 100
}

const handleClickBox = async (stage) => {
  console.log('handleClickBox', stage)
  if (!mwrData.cpUserInfo.cpUserId) {
    toastService.showSmall(t('payment.validateUser.noUserText'))
    return
  }
  const boxStatus = getBoxStatus(stage)
  if (boxStatus === 0) {
    toastService.showSmall(t('mwr.dragon.treasureBox.notReach'))
    return
  }
  if (boxStatus === 2) {
    toastService.showSmall(t('mwr.dragon.treasureBox.received'))
    return
  }
  const res = await MwrActApi.receiveBoxReward({
    stage,
  })
  const rewardData = res // { stage, rewardCode, rewardItems }

  // const rewardData = {
  //   stage,
  //   rewardCode: 'super_box',
  //   rewardItems: [
  //     {
  //       itemId: 'gold_diamond',
  //       quantity: 19999,
  //     }
  //   ]
  // }

  // 奖品的内容在record里面
  // console.log('mwrData.recordList', mwrData.recordList)
  // const rewardData = mwrData.recordList.find(item => item.stage === stage)
  // todo 领取奖励提示
  // toastService.showSmall(t('mwr.dragon.treasureBox.receiveSuccess'))
  emit('openRewardBoxDialog', rewardData)
  mwrFn.updateBoxRewardRecord()
  // state.rewardBoxDialog.visible = true
  // state.rewardBoxDialog.rewardItems = rewardItems
}
</script>
  
  <style scoped lang="less" src="./mobile_style.less"></style>
  